/** @jsx jsx */

import React, { Fragment as _, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import Layout from 'components/Layouts/Layout';
import placeholder from 'assets/placeholder.png';
import EditableText from 'components/lib/EditableText';
import Image from 'components/lib/Image';
//
import getTempTextImageData from 'services/getTempTextImageContinueBtnData';
import TermsAndConditions from './TermsAndConditions';

const FullPageText = ({ children, ...props }) => {
  return (
    <div
      css={css`
        padding: 10px;
      `}
    >
      {children}

      <TermsAndConditions />
    </div>
  );
};

export default FullPageText;
